const LabelCounter = ({
  id,
  label,
  count,
  limit,
  labelClassName,
  countClassName,
  containerClassName,
}) => (
  <div className={`${containerClassName} fl jc-sb`}>
    <label htmlFor={id} className={labelClassName}>
      {label}
    </label>
    <p className={countClassName}>{`${count}/${limit}`}</p>
  </div>
);

export default LabelCounter;
